import {AfterViewInit, Component, inject}        from '@angular/core';
import {ReactiveFormsModule}                     from '@angular/forms';
import {MoodRecordLogIntf}                       from '@djsharkk/logr-types';
import {gsap}                                    from 'gsap';
import {v4 as uuidv4}                            from 'uuid'
import {MenuCrudPanelContentBase}                from '../../menu-crud-panel-content-base';
import {MenuCrudPanelMoodService}                from '../../menu-crud-panel-top/menu-crud-panel-mood-top/menu-crud-panel-mood.service';
import {MenuCrudPanelBotComponent, PanelBtnIntf} from '../menu-crud-panel-bot.component';

@Component({
			   selector   : 'app-menu-crud-panel-mood-bot',
			   imports    : [
				   ReactiveFormsModule,
				   MenuCrudPanelBotComponent
			   ],
			   templateUrl: './menu-crud-panel-mood-bot.component.html',
			   styleUrl   : './menu-crud-panel-mood-bot.component.css'
		   })
export class MenuCrudPanelMoodBotComponent extends MenuCrudPanelContentBase<MoodRecordLogIntf, undefined> implements AfterViewInit {
	svcMenuCrudMood = inject(MenuCrudPanelMoodService)


	btnsL: [PanelBtnIntf, PanelBtnIntf] = [
		{
			icon: 'plus',
			func: () => this.addRecords(),
			uuid: uuidv4()
		},
		{
			icon: 'plus',
			func: () => this.addRecords(),
			uuid: uuidv4()
		}

	]

	constructor() {
		super('mood', false);

	}

	ngAfterViewInit(): void {
		setTimeout(() => {
			const outer = document.getElementById('MoodMatrixOuter');

			if (outer) {
				// Calculate the center scroll positions for x and y
				const scrollX = (outer.scrollWidth - outer.clientWidth) / 2;
				const scrollY = (outer.scrollHeight - outer.clientHeight) / 2;

				// Animate scrolling to the center
				gsap.to(outer, {
					duration: 0.5,
					ease    : 'power2.out',
					scrollTo: {
						x: scrollX, // Center horizontally
						y: scrollY  // Center vertically
					}
				});
			}
		}, 0);
	}

	addRecords() {

		Promise.all(
			this.svcMenuCrudMood.selected.map((term) => this.svcFirebaseTools.recCreate('mood_records_log', this.svcDataFactory.svcDataMood.buildMoodRecord(term)))
		).then(() => {
			// this.dialogRef.close();
			this.svcMenuCrudMood.selected = [];
		}).catch((error) => {
			console.error('Error adding records: ', error);
		});
	}


}
